import axios from 'axios';
import global from './global';
import { Message, MessageBox } from 'element-ui';

const service = axios.create({
  baseURL: global.API_URL,
  timeout: 5000,
});
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Request interceptors
service.interceptors.request.use(
  (config) => {
    if (config.url !== undefined && config.url.indexOf('Register') >= 0) {
      return config;
    }
    const token = global.getAccessToken();
    // Add X-Token header to every request, you can add other custom headers here
    if (token && token !== '') {
      config.headers.Authorization = 'bearer ' + global.getAccessToken();
    }
    // if (UserModule.token) {
    //   // config.headers['X-Token'] = getToken();
    //   config.headers.Authorization = 'bearer ' + getAccessToken();
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 20000: valid
    // code == 50008: invalid token
    // code == 50012: already login in other place
    // code == 50014: token expired
    // code == 60204: account or password is incorrect
    // You can change this part for your own usage.
    if (response.status === 200) {
        return response.data;
      }
  },
  (error) => {
    if (error.response.status === 401) {
      // MessageBox.confirm(
      //   '你已被登出，可以取消继续留在该页面，或者重新登录',
      //   '确定登出',
      //   {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning',
      //   },
      // ).then(() => {
      //   window.localStorage['ESResource_RedirectURL'] = window.location.href;
      //   (window as any).mgr.signinRedirect();
      // });
      window.localStorage['ESResource_RedirectURL'] = window.location.href;
      (window as any).mgr.signinRedirect();
      return Promise.reject(new Error('error with code: 401'));
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
